import actions from './actions';
import apiActions from './api-actions';
import getters from './getters';
import mutations from './mutations';
import apiMutations from './api-mutations';
import initialState from './state';

export default {
  namespaced: true,

  actions: { ...actions, ...apiActions },
  mutations: { ...mutations, ...apiMutations },
  state: initialState(),
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/index.js